import z from 'zod';

export const isEmailValid = (email: string) =>
  z.string().email().safeParse(email).success;
